var map = {
	"./conference-icon.png": 7544,
	"./covidlivedata.png": 2617,
	"./driving-alerts-toronto.png": 6989,
	"./jokes generator.png": 6163,
	"./latest-icon.png": 1700,
	"./mobile-icon.png": 9320,
	"./pc-icon.png": 3171,
	"./pcpoints-wApp.png": 5918,
	"./sb-wApp.png": 3463,
	"./sbscanpay-wApp.png": 26,
	"./sudoku-wApp.png": 1998,
	"./tictactoe-wApp.png": 8527,
	"./timsrewards-wApp.png": 2660,
	"./wearable-icon.png": 1681,
	"./website-logo.png": 6765,
	"./worklog-icon.png": 7320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7128;